<template>
    <group-backend-layout :page-title="pageTitle">
        <template #page_controls></template>

        <GroupClassroomInstructor :classroom="classroom" />

        <div class="mt-4">
            <GroupClassroomManageGoalsTable :classroom="classroom" />

            <div class="mt-8">
                <group-classroom-students-archived-overview
                    :classroom="classroom"
                ></group-classroom-students-archived-overview>
            </div>
        </div>
    </group-backend-layout>
</template>

<script>
import GroupBackendLayout from "@/_Layouts/GroupBackendLayout";
import GroupClassroomStudentsArchivedOverview from "@/Components/GroupClassroomStudentsArchivedOverview";
import GroupClassroomAddStudentModal from "@/Components/GroupClassroomAddStudentModal";
import GroupClassroomInstructor from "@/Components/GroupClassroomInstructor";
import GroupClassroomManageGoalsTable from "@/Components/GroupClassroomManageGoalsTable";

export default {
    name: "GroupClassroomShowArchived",
    components: {
        GroupClassroomManageGoalsTable,
        GroupClassroomInstructor,
        GroupClassroomAddStudentModal,
        GroupClassroomStudentsArchivedOverview,
        GroupBackendLayout,
    },
    props: {
        classroom: {
            type: Object,
            default: {},
        },
        students: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    computed: {
        pageTitle() {
            return (
                this.classroom.name +
                '<span class="ml-2 rounded bg-gray-400 px-2 py-1 text-[12px] text-gray-800">Archived</span>'
            );
        },
    },
};
</script>
